import React from "react";

export default function Portal() {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Portal</h1>
      <p>Du bist eingeloggt.</p>
    </div>
  );
}
